/**
 * Caitlyn Yordle Snap Trap params (wiki Ability data rank-1).
 */

export const CAITLYN_W_RANGE = 800;
export const CAITLYN_W_MANA = 20;
export const CAITLYN_W_COOLDOWN = 0.5;
export const CAITLYN_W_DURATION_SEC = 30;
export const CAITLYN_W_EFFECT_DELAY_SEC = 1;
export const CAITLYN_W_TRAP_RADIUS = 15;
export const CAITLYN_W_ROOT_SEC = 1.5;
export const CAITLYN_W_RECHARGE = 26;
